import { Authentication } from '@/common/domain/auth/Authentication';
import { RouteLocationNormalized } from 'vue-router';
import { LoginContextRepository } from '@/common/domain/login/LoginContextRepository';
import router from '@/router/router';

export const authenticationGuard =
  (authentication: Authentication, loginContextRepository: LoginContextRepository) =>
  async (to: RouteLocationNormalized): Promise<void> => {
    if (to.meta.accessibleUnauthenticated) {
      return;
    }

    const authenticated = await authentication.isAuthenticated();
    if (!authenticated) {
      loginContextRepository.storeLoginContext({ redirectUrl: window.location.href });
      await router.push({ name: 'login' });
    }
  };
